import React from "react";
import "../styles/Title.css";

const Title = () => {
  return (
    <div className="app-title">
      <span className="title-name">Erika</span>
      <span className="title-ampersand">&</span>
      <span className="title-name">Camilo</span>
    </div>
  );
};

export default Title;
